import { ScheduleQueueInterface } from '@splixer/common';
import { AnyHash, uNumber, uString, Uuid } from '@hidat/huijs-common';
import { Expose, Transform } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';
import * as dayjs from 'dayjs';

export class PlayerScheduleQueue implements ScheduleQueueInterface {
  @Expose({ name: 'id' })
  id: Uuid | undefined;

  @Expose({ name: 'instance_id' })
  instanceId: number | undefined;

  @Expose({ name: 'listener_id' })
  listenerId: Uuid | undefined;

  @Expose({ name: 'source_type' })
  sourceType: uString;

  @Expose({ name: 'source_id' })
  sourceId: uNumber;

  @Expose({ name: 'playback_constraints' })
  playbackConstraints: AnyHash | undefined;

  @Expose({ name: 'seq_num' })
  seqNum: uNumber;

  @Expose({ name: 'play_status' })
  playStatus = 0;

  @Expose({ name: 'played_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  playedAt: dayjs.Dayjs | undefined;

  @Expose({ name: 'tenant_id' })
  tenantId: Uuid | undefined;

  @Expose({ name: 'created_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined;

  @Expose({ name: 'updated_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  updatedAt: dayjs.Dayjs | undefined;

  @Expose({ name: 'updated_count' })
  updatedCount: number | undefined;
}
